/* FontDoctor upgrade serial field. GENERATED by scripts/build-theme-asset.mjs - do not edit. */
(function () {
  "use strict";
// Faithful port of -[FDAppDelegate isValidWindowCache:] and its helpers
// (fontdoctor-mac/FontDoctor Project/FontDoctor/FDAppDelegate.m).

const SERIAL_STATUS = Object.freeze({
  V10_SINGLE: 1,
  V10_MULTI: 2,
  PRE_V10: -2,
  INVALID: -1,
});

const ASCII_A = 65;
const ASCII_Z = 90;
const INT_MAX = 2147483647;
const INT_MIN = -2147483648;

// Mimics -[NSString intValue]: skips leading spaces/tabs, one optional sign,
// then leading digits; 0 if none; clamps to 32-bit int on overflow.
function objcIntValue(str) {
  let i = 0;
  const n = str.length;
  while (i < n && (str[i] === " " || str[i] === "\t")) i++;
  let negative = false;
  if (i < n && (str[i] === "+" || str[i] === "-")) {
    negative = str[i] === "-";
    i++;
    while (i < n && (str[i] === " " || str[i] === "\t")) i++;
  }
  let value = 0;
  let sawDigit = false;
  while (i < n && str[i] >= "0" && str[i] <= "9") {
    sawDigit = true;
    if (value <= INT_MAX) value = value * 10 + (str.charCodeAt(i) - 48);
    i++;
  }
  if (!sawDigit) return 0;
  if (negative) return value > -INT_MIN ? INT_MIN : -value;
  return value > INT_MAX ? INT_MAX : value;
}

function sumCodes(base, maxLen) {
  let sum = 0;
  for (let i = 0; i < maxLen && i < base.length; i++) sum += base.charCodeAt(i);
  return sum;
}

function checksumChar(ch) {
  const code = ch.charCodeAt(0);
  return code >= ASCII_A && code <= ASCII_Z ? String(code - ASCII_A) : ch;
}

// Shared body of validateSingleWindowCache / validateMultipleWindowCache.
function validateV10(sn, maxLen) {
  if (sn.length < 25) return false;
  const base = sn.substring(10).replaceAll("-", "");
  // Obj-C: (getBase.length - kMaxLen) is unsigned; if negative it wraps and
  // substringWithRange: throws NSRangeException. Treat as invalid.
  if (base.length < maxLen) return false;
  const sum = sumCodes(base, maxLen);
  let checksum = "";
  let isValid = false; // stays NO if the checksum portion is empty
  for (let i = maxLen; i < base.length; i++) {
    checksum += checksumChar(base[i]);
    isValid = sum === objcIntValue(checksum);
  }
  return isValid;
}

function validateOther(sn) {
  const maxLen = 12;
  if (sn.length <= maxLen) return false;
  const base = sn.substring(5).replaceAll("-", "");
  const sum = sumCodes(base, maxLen);
  let checksum = "";
  for (let i = maxLen; i < base.length; i++) checksum += checksumChar(base[i]);
  return sum === objcIntValue(checksum); // empty checksum compares against 0
}

/** Raw port: no normalization. Returns 1, 2, -2 or -1. */
function rawSerialStatus(sn) {
  if (validateV10(sn, 9)) return SERIAL_STATUS.V10_SINGLE;
  if (validateV10(sn, 11)) return SERIAL_STATUS.V10_MULTI;
  if (validateOther(sn)) return SERIAL_STATUS.PRE_V10;
  return SERIAL_STATUS.INVALID;
}

function normalizeSerial(sn) {
  return typeof sn === "string" ? sn.trim().toUpperCase() : "";
}

/** Trims and uppercases, then applies the faithful port with no extra checks. */
function faithfulSerialStatus(sn) {
  const normalized = normalizeSerial(sn);
  if (!normalized) return SERIAL_STATUS.INVALID;
  return rawSerialStatus(normalized);
}

const MAX_SERIAL_LENGTH = 64;

// Uppercase letters and digits in dash-separated groups: no leading, trailing
// or doubled dashes. Restricting to [A-Z0-9] also means every checksum char
// maps to digits, so intValue can't be fooled by signs, spaces or junk.
const SERIAL_SHAPE = /^[A-Z0-9]+(?:-[A-Z0-9]+)*$/;

// Per-validator structure the faithful port doesn't enforce: the prefix that
// gets skipped, and the number of summed characters.
const STRUCTURE = {
  [SERIAL_STATUS.V10_SINGLE]: { skip: 10, maxLen: 9 },
  [SERIAL_STATUS.V10_MULTI]: { skip: 10, maxLen: 11 },
  [SERIAL_STATUS.PRE_V10]: { skip: 5, maxLen: 12 },
};

function hasRealChecksum(sn, status) {
  const { skip, maxLen } = STRUCTURE[status];
  const base = sn.substring(skip).replaceAll("-", "");
  return base.length > maxLen && sumCodes(base, maxLen) > 0;
}

// Known v10 headers (dashes removed). The trailing 1/5 is marketing tracking only.
const V10_HEADERS = {
  FD10SUL1: { status: SERIAL_STATUS.V10_SINGLE, maxLen: 9 },
  FD10SUL5: { status: SERIAL_STATUS.V10_SINGLE, maxLen: 9 },
  FD10VLA1: { status: SERIAL_STATUS.V10_MULTI, maxLen: 11 },
  FD10VLA5: { status: SERIAL_STATUS.V10_MULTI, maxLen: 11 },
};
const V10_HEADER_LEN = 8;
// Sums are always 3 digits (432-990), and K-Z would map to two digits.
const V10_CHECKSUM = /^[A-J0-9]{3}$/;

function strictV10Status(compact) {
  const spec = V10_HEADERS[compact.substring(0, V10_HEADER_LEN)];
  if (!spec || compact.length !== V10_HEADER_LEN + spec.maxLen + 3) return SERIAL_STATUS.INVALID;
  const body = compact.substring(V10_HEADER_LEN, V10_HEADER_LEN + spec.maxLen);
  const checksum = compact.substring(V10_HEADER_LEN + spec.maxLen);
  if (!V10_CHECKSUM.test(checksum)) return SERIAL_STATUS.INVALID;
  const mapped = [...checksum].map(checksumChar).join("");
  return mapped === String(sumCodes(body, spec.maxLen)) ? spec.status : SERIAL_STATUS.INVALID;
}

/**
 * Trims and uppercases, then returns 1 (v10 single), 2 (v10 multi), -2 (pre-v10)
 * or -1 (invalid). Stricter than the Mac app: FD10 input must match a known v10
 * header, length and checksum exactly (dash placement is ignored); other input
 * must have a plausible shape and a non-empty checksum.
 */
/** Trims, uppercases and turns internal whitespace (with adjacent dashes) into one dash. */
function canonicalSerial(sn) {
  // Dashes are stripped before summing, so this can't smuggle whitespace into the checksum.
  return normalizeSerial(sn).replace(/[\s-]*\s[\s-]*/g, "-");
}

function serialStatus(sn) {
  const normalized = canonicalSerial(sn);
  if (normalized.length > MAX_SERIAL_LENGTH || !SERIAL_SHAPE.test(normalized)) {
    return SERIAL_STATUS.INVALID;
  }
  const compact = normalized.replaceAll("-", "");
  if (compact.startsWith("FD10")) return strictV10Status(compact);
  const status = rawSerialStatus(normalized);
  if (status === SERIAL_STATUS.INVALID || !hasRealChecksum(normalized, status)) {
    return SERIAL_STATUS.INVALID;
  }
  return status;
}

/** Any serial up to and including v10 qualifies for the v11 upgrade. */
function isUpgradeEligible(sn) {
  return serialStatus(sn) !== SERIAL_STATUS.INVALID;
}

  window.FontDoctorSerial = { serialStatus, isUpgradeEligible, canonicalSerial, SERIAL_STATUS, initField, initAll };
// Product-page controller for the FontDoctor upgrade serial field.
// Bundled after serial.js into assets/fontdoctor-serial.js by scripts/build-theme-asset.mjs;
// `serialStatus`, `isUpgradeEligible` and `canonicalSerial` are in scope.

const MESSAGES = {
  empty: "Enter your current FontDoctor serial number (v10 or earlier).",
  invalid: "That serial number isn't valid for the v11 upgrade. Please check it, or contact support.",
  valid: "Serial number accepted.",
};

const PAYMENT_BUTTON_SELECTOR = ".shopify-payment-button, [data-shopify='payment-button'], dynamic-checkout";

function findForm(wrapper) {
  const formId = wrapper.getAttribute("data-fd-form-id");
  return (
    (formId && document.getElementById(formId)) ||
    wrapper.closest("form") ||
    document.querySelector("form[action*='/cart/add']")
  );
}

function currentVariantId(form) {
  const idField = form && form.querySelector("[name='id']");
  if (idField && idField.value) return String(idField.value);
  return new URLSearchParams(window.location.search).get("variant") || "";
}

function setDisabledByUs(el, disabled) {
  if (disabled) {
    if (!el.disabled) {
      el.disabled = true;
      el.setAttribute("data-fd-disabled", "");
    }
  } else if (el.hasAttribute("data-fd-disabled")) {
    el.disabled = false;
    el.removeAttribute("data-fd-disabled");
  }
}

function setHiddenByUs(el, hidden) {
  if (hidden) {
    if (!el.hasAttribute("data-fd-hidden")) {
      el.setAttribute("data-fd-hidden", el.style.display);
      el.style.display = "none";
    }
  } else if (el.hasAttribute("data-fd-hidden")) {
    el.style.display = el.getAttribute("data-fd-hidden");
    el.removeAttribute("data-fd-hidden");
  }
}

function initField(wrapper) {
  if (wrapper.__fdSerial) return wrapper.__fdSerial;
  const input = wrapper.querySelector("input");
  const message = wrapper.querySelector("[data-fd-message]");
  const upgradeId = String(wrapper.getAttribute("data-fd-upgrade-variant") || "");
  if (!findForm(wrapper) || !input || !upgradeId) return null;

  // Looked up each time: some themes re-render the product form on variant change.
  const getForm = () => findForm(wrapper);
  const scope = () => {
    const form = getForm();
    return (form && form.closest("section, product-info, .product")) || document;
  };
  let touched = false;
  let lastVariant = null;

  const isUpgrade = () => currentVariantId(getForm()) === upgradeId;
  const isValid = () => isUpgradeEligible(input.value);
  const submitButtons = () => {
    const form = getForm();
    if (!form) return [];
    return [...form.querySelectorAll("button[type='submit'], input[type='submit'], button:not([type])"),
     ...(form.id ? document.querySelectorAll(`[form='${form.id}'][type='submit']`) : [])];
  };

  function render() {
    const upgrade = isUpgrade();
    const valid = upgrade && isValid();
    wrapper.hidden = !upgrade;
    input.disabled = !upgrade; // disabled inputs aren't submitted, so no stray property
    input.required = upgrade;
    input.setCustomValidity(upgrade && !valid ? (input.value.trim() ? MESSAGES.invalid : MESSAGES.empty) : "");
    input.setAttribute("aria-invalid", String(upgrade && touched && !valid));
    if (message) {
      const text = !upgrade ? "" : valid ? MESSAGES.valid : touched ? (input.value.trim() ? MESSAGES.invalid : MESSAGES.empty) : "";
      const state = !upgrade || !text ? "" : valid ? "valid" : "invalid";
      if (message.textContent !== text) message.textContent = text;
      if (message.getAttribute("data-fd-state") !== state) message.setAttribute("data-fd-state", state);
    }
    submitButtons().forEach((b) => setDisabledByUs(b, upgrade && !valid));
    scope().querySelectorAll(PAYMENT_BUTTON_SELECTOR).forEach((el) => setHiddenByUs(el, upgrade));
  }

  function sync() {
    const v = currentVariantId(getForm());
    if (v !== lastVariant) {
      lastVariant = v;
      touched = touched && v === upgradeId;
    }
    render();
  }

  function block(event) {
    if (!isUpgrade()) return;
    if (isValid()) {
      input.value = canonicalSerial(input.value);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    touched = true;
    render();
    input.focus();
  }

  input.addEventListener("input", () => {
    const pos = input.selectionStart;
    const upper = input.value.toUpperCase();
    if (upper !== input.value) {
      input.value = upper;
      if (pos != null) input.setSelectionRange(pos, pos);
    }
    touched = true;
    render();
  });
  input.addEventListener("blur", () => {
    if (isValid()) input.value = canonicalSerial(input.value);
    touched = true;
    render();
  });

  // Capture phase on document runs before the theme's own submit/click handlers
  // (e.g. Dawn's <product-form> fetch submit), so stopImmediatePropagation blocks them.
  document.addEventListener("submit", (e) => { if (wrapper.isConnected && e.target === getForm()) block(e); }, true);
  document.addEventListener("click", (e) => {
    const btn = e.target.closest && e.target.closest("button, input[type='submit']");
    if (wrapper.isConnected && btn && submitButtons().includes(btn)) block(e);
  }, true);

  // Variant changes: generic change events, Dawn's pub/sub, and a cheap poll as a fallback.
  document.addEventListener("change", () => setTimeout(sync, 0));
  document.addEventListener("variant:change", sync);
  window.addEventListener("popstate", sync);
  if (typeof window.subscribe === "function" && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => setTimeout(sync, 0));
  }
  const poll = setInterval(() => {
    if (!wrapper.isConnected) return clearInterval(poll);
    if (currentVariantId(getForm()) !== lastVariant) sync();
    else render(); // re-apply if the theme re-enabled buttons or re-rendered the form
  }, 400);

  sync();
  const api = { sync, isUpgrade, isValid, input };
  wrapper.__fdSerial = api;
  return api;
}

function initAll() {
  document.querySelectorAll("[data-fd-serial-field]").forEach(initField);
}

function start() {
  initAll();
  // Pick up fields in sections the theme re-renders (e.g. Dawn's variant-change HTML swap).
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();

})();
